<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    深云站<br>
站点介绍<br>
深云站位于北环大道和龙珠大道交汇处，北环大道及龙珠大道以北。北侧是塘朗山南麓及深云车辆段，西北角有香瑞园小区，南侧有深云村小区，东端是深云北环天桥，西端有北环南坪立交桥。深云站装修设计简约，以灰色大理石橙黄色柱子为主体，体现“简单、大方”的装修风格。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:09	23:44	7号线	3分35秒	5分55秒<br>
太安	06:28	23:13	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:15	23:44	7号线	4分钟	5分55秒<br>
太安	06:33	23:13	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:15	00:44	7号线	4分钟	5分55秒<br>
太安	06:33	00:13	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
B出入口:<br>
北环大道、深云村、深圳市中级人民法院刑事审判区<br><br>
C出入口:<br>
北环大道北侧（东）、侨城北公交综合车场、深圳地铁深云车辆段<br><br>
D出入口:<br>
北环大道北侧（西）、香瑞园<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 深云村<br>
201路、M240路、M364路、M358路、58路、B682路、41路、高峰专线21<br><br>
D出入口:<br>
公交站名： 侨城北公交综合车场<br>
201路，M203路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>